
export function findCountryCode(placeObject) {
  if(!placeObject.address_components) return '';
  let countryData = placeObject.address_components.find(c => c.types.includes('country'));
  if(countryData && countryData.short_name) {
    return countryData.short_name;
  }
  return '';
};
